import * as Icons from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

interface CopyToClipboardProps {
  text: string;
  tooltipText?: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
}

export const CopyToClipboard = ({
  text,
  children,
  tooltipText = 'Copiar',
  icon
}: CopyToClipboardProps) => {
  const clipboardButton = (
    <Tooltip title={tooltipText}>
      <Button
        size="small"
        ghost
        icon={icon ?? <Icons.CopyTwoTone style={{ fontSize: 12 }} />}
        onClick={() => navigator.clipboard.writeText(text)}
      />
    </Tooltip>
  );

  return children ? (
    <div className="flex">
      {children} {clipboardButton}
    </div>
  ) : (
    clipboardButton
  );
};
